export const ADMIN = 'admin';
export const TRADE = 'trade';
export const ADV = 'adv';
export const PUB = 'pub';
